const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID || ''
const AUTH_URL = process.env.REACT_APP_AUTH_URL || ''
const AUTH_REALM = process.env.REACT_APP_AUTH_REALM || ''
const AUTH_SCOPES = process.env.REACT_APP_AUTH_SCOPES || ''

export { AUTH_CLIENT_ID, AUTH_URL, AUTH_REALM, AUTH_SCOPES }
